import React from 'react'
import "./style.css"
import { useNavigate } from 'react-router-dom'
const ThankYouComponent = () => {
   const onClick = ()=>{
    window.location.reload()
   }
    return (
        <div className="thank-you-container">
            <div className="thank-you-card">
                <h2 className="thank-you-text mb-4">Thank You!</h2>
                <svg className="checkmark" viewBox="0 0 52 52">
                    <circle className="checkmark-circle" cx="26" cy="26" r="25" fill="none" />
                    <path className="checkmark-check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8" />
                </svg>
                <div className='message-detail' >
                    <span>We've received your request. </span><br />
                    <span>Someone from our team will contact you soon. </span>
                </div>

                <div className="btn-container">
                    <div className="center">
                        <button className="btn" onClick={onClick} >
                            <svg viewBox="0 0 180 59" class="border">
                                <polyline points="179,1 179,59 1,59 1,1 179,1" class="bg-line" />
                                <polyline points="179,1 179,59 1,59 1,1 179,1" class="hl-line" />
                            </svg>
                            <span>Back To Home</span>
                        </button>
                    </div>
                </div>

            </div>

        </div>
    )
}

export default ThankYouComponent